import { useState } from "react";
import { Sparkles, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { img } from "@/lib/api";

const LABEL = { upscaled: "upscaled to print size", sharpened: "sharpened" };

export default function CompareDialog({ photo, onClose }) {
  const [pos, setPos] = useState(50);
  const [hold, setHold] = useState(false);
  if (!photo) return null;
  const split = hold ? 100 : pos;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl border-0 bg-[#1E1B24] p-0 text-white sm:rounded-xl [&>button:last-child]:hidden" data-testid="compare-dialog">
        <DialogTitle className="sr-only">Before and after enhancement</DialogTitle>
        <div className="flex items-center justify-between px-5 pt-4">
          <p className="flex items-center gap-2 text-sm font-medium"><Sparkles className="h-4 w-4 text-[#FFD166]" />Enhanced for print · {photo.fixes.map((f) => LABEL[f] || f).join(" + ")}</p>
          <button type="button" onClick={onClose} data-testid="compare-close-btn" className="rounded-full p-1.5 hover:bg-white/10" aria-label="Close"><X className="h-4 w-4" /></button>
        </div>
        <div
          className="relative mx-auto mt-3 w-[calc(100%-2.5rem)] select-none overflow-hidden rounded-lg bg-black"
          style={{ aspectRatio: `${photo.width} / ${photo.height}`, maxHeight: "70vh", maxWidth: `calc(70vh * ${photo.width} / ${photo.height})` }}
          onPointerDown={() => setHold(true)} onPointerUp={() => setHold(false)} onPointerLeave={() => setHold(false)}
          data-testid="compare-stage"
        >
          <img src={img(photo.url)} alt="After enhancement" className="absolute inset-0 h-full w-full object-contain" draggable={false} />
          <div className="absolute inset-0 overflow-hidden" style={{ width: `${split}%` }}>
            <img src={img(photo.url_source)} alt="Before enhancement" className="absolute inset-0 h-full object-contain" style={{ width: `${10000 / Math.max(split, 1)}%`, maxWidth: "none" }} draggable={false} />
          </div>
          <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(0,0,0,.4)]" style={{ left: `calc(${split}% - 1px)` }} />
          <span className="pointer-events-none absolute left-3 top-3 rounded-full bg-black/60 px-2.5 py-1 text-[11px] font-medium" data-testid="compare-before-label">Before</span>
          <span className="pointer-events-none absolute right-3 top-3 rounded-full bg-[#3B5BDB] px-2.5 py-1 text-[11px] font-medium" data-testid="compare-after-label">After</span>
        </div>
        <div className="px-5 pb-5 pt-3">
          <input type="range" min={0} max={100} value={pos} onChange={(e) => setPos(Number(e.target.value))} data-testid="compare-slider" aria-label="Compare before and after" className="w-full accent-[#3B5BDB]" />
          <p className="mt-2 text-center text-xs text-white/60">Drag the slider, or press and hold the picture to see the original.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
